import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './purchase-cancellation.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PurchaseCancellationDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const purchaseCancellationEntity = useAppSelector(state => state.purchaseCancellation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="purchaseCancellationDetailsHeading">
          <Translate contentKey="comexApp.purchaseCancellation.detail.title">PurchaseCancellation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{purchaseCancellationEntity.id}</dd>
          <dt>
            <span id="reason">
              <Translate contentKey="comexApp.purchaseCancellation.reason">Reason</Translate>
            </span>
          </dt>
          <dd>{purchaseCancellationEntity.reason}</dd>
          <dt>
            <span id="managerApproval">
              <Translate contentKey="comexApp.purchaseCancellation.managerApproval">Manager Approval</Translate>
            </span>
          </dt>
          <dd>{purchaseCancellationEntity.managerApproval ? 'true' : 'false'}</dd>
          <dt>
            <span id="comexAdminApproval">
              <Translate contentKey="comexApp.purchaseCancellation.comexAdminApproval">Comex Admin Approval</Translate>
            </span>
          </dt>
          <dd>{purchaseCancellationEntity.comexAdminApproval ? 'true' : 'false'}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="comexApp.purchaseCancellation.status">Status</Translate>
            </span>
          </dt>
          <dd>{purchaseCancellationEntity.status}</dd>
          <dt>
            <span id="result">
              <Translate contentKey="comexApp.purchaseCancellation.result">Result</Translate>
            </span>
          </dt>
          <dd>{purchaseCancellationEntity.result}</dd>
          <dt>
            <Translate contentKey="comexApp.purchaseCancellation.quotation">Quotation</Translate>
          </dt>
          <dd>{purchaseCancellationEntity.quotation ? purchaseCancellationEntity.quotation.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/purchase-cancellation" replace data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/purchase-cancellation/${purchaseCancellationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PurchaseCancellationDetail;
